
import { useState, useEffect } from "react";
import axios from "axios";
import "./login.css"; // Importe o CSS correspondente
import image1 from "../assets/image-1.png";
import image2 from "../assets/image-2.png";
import loading_img from "../assets/loading.gif";

import { useNavigate } from "react-router-dom";

const Swal = require('sweetalert2')
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  const clickBuscar = async () => {

    var id_pedido = document.getElementById('id_pedido').value;

    if (id_pedido == '') {
      toast.error('Por favor digite o ID do pedido!');
      return false;
    }

    setLoading(true)

    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/getPedidosRefill.php',
      headers: {'Content-Type': 'application/json'},
      data: {token: '2a780f67128d8194c33e2ec3980061ab', idpedido: id_pedido}
    };

    try {
      var dados = await axios(options);
      setLoading(false)


      var resposta = dados.data;
      console.log(resposta)

      if(resposta.success == false){
        toast.error(resposta.message);
        return false;
      }

      localStorage.setItem('@dados_pedido',JSON.stringify(resposta.data))
      localStorage.setItem('@idpedido',''+id_pedido)

      navigate('/status?id='+id_pedido)

    } catch (error) {
        setLoading(false)
        console.log(error)
        toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }
     

  }


  return (
    <>
      <ToastContainer />

      <div className="wrapper">
      <div className="inner" style={{ marginTop: "-700px" }}>
          <div className="div1">
            <h3>Detalhes do Pedido</h3>

            <div
  className="form-holder"
  style={{
    background: "rgb(237, 237, 237)",
    padding: "10px",
    borderRadius: "5px",
    marginBottom: "-25px",
  }}
>


              <span className="lnr lnr-user"></span>
              <input type="tel" id="id_pedido" className="form-control" placeholder="ID do Pedido" />
            </div>

            {loading == false&&(<button type="submit" onClick={() => { clickBuscar() }}>
              <span>Buscar</span>
            </button>)}

            {loading == true&&(<button type="submit" >
              <img src={loading_img} alt="" style={{width:25,height:25}} />
            </button>)}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
